export default __webpack_public_path__ + "static/media/tick.03bf2807.svg";